import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UISliceState {
  theme: 'light' | 'dark' | 'military';
  sidebarCollapsed: boolean;
  activeView: string;
  modalOpen: boolean;
  modalContent: string | null;
  notificationsOpen: boolean;
  voiceEnabled: boolean;
  soundEnabled: boolean;
}

const initialState: UISliceState = {
  theme: 'military',
  sidebarCollapsed: false,
  activeView: 'dashboard',
  modalOpen: false,
  modalContent: null,
  notificationsOpen: false,
  voiceEnabled: true,
  soundEnabled: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<'light' | 'dark' | 'military'>) => {
      state.theme = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setActiveView: (state, action: PayloadAction<string>) => {
      state.activeView = action.payload;
    },
    openModal: (state, action: PayloadAction<string>) => {
      state.modalOpen = true;
      state.modalContent = action.payload;
    },
    closeModal: (state) => {
      state.modalOpen = false;
      state.modalContent = null;
    },
    toggleNotifications: (state) => {
      state.notificationsOpen = !state.notificationsOpen;
    },
    toggleVoice: (state) => {
      state.voiceEnabled = !state.voiceEnabled;
    },
    toggleSound: (state) => {
      state.soundEnabled = !state.soundEnabled;
    },
  },
});

export const {
  setTheme,
  toggleSidebar,
  setActiveView,
  openModal,
  closeModal,
  toggleNotifications,
  toggleVoice,
  toggleSound,
} = uiSlice.actions;

export default uiSlice.reducer;
